import React from "react";
import '@shared/styles/AppBlack.css';

const AppBlack = () => {
    return <></>
}

export default AppBlack